import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../Logo";
import { getAppConfig } from "../../sim/env";

/**
 * Shared site FOOTER — brand line, the site's own pages (the top nav is too tight on phones to carry them, and
 * the footer logo was otherwise the only way off a sub-page), then the legal/policy + contact links. Those are
 * required for payment-processor (Stripe) account activation, and reviewers expect them to be reachable from
 * the site, so this footer is placed on every public page. The operator named in the copyright is Anima — the
 * same one the legal pages name.
 */
export function SiteFooter() {
  const [ksUrl, setKsUrl] = useState("");
  useEffect(() => {
    let alive = true;
    void getAppConfig().then((c) => {
      if (alive && c.kickstarter.on) setKsUrl(c.kickstarter.campaignUrl || c.prelaunch.kickstarterUrl);
    });
    return () => { alive = false; };
  }, []);
  return (
    <footer className="site-foot">
      <div className="site-foot-brand">
        <Link to="/" aria-label="Shelf Garden home"><Logo height={26} tone="light" /></Link>
        <span className="site-foot-dim">A cozy gardening game.</span>
      </div>
      <div className="site-foot-navs">
        <nav className="site-foot-links">
          <Link to="/play">Play</Link>
          <Link to="/whats-new">What's New</Link>
          <Link to="/shop">Shop</Link>
          <Link to="/garden-club">Garden Club</Link>
          <Link to="/profile">Profile</Link>
          {ksUrl && <a href={ksUrl} target="_blank" rel="noopener noreferrer">Back Shelf Garden on Kickstarter</a>}
        </nav>
        <nav className="site-foot-links">
          <Link to="/redeem">Redeem a code</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/refunds">Refunds</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </div>
      <div className="site-foot-copy">© {new Date().getFullYear()} Anima. Shelf Garden is a game by Anima.</div>
    </footer>
  );
}
